export const actionCreators = {
    LogIn: (username, password, redirectTo) => (dispatch, getState) => {
    },
    LogOff: () => (dispatch, getState) => {
    }
};


